/**
 * Fechas de sincronización (SQLite datetime('now') en UTC, sin zona).
 */

export function parseSyncDate(raw) {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (!s) return null;
  let iso = s;
  if (!/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) {
    iso = s.includes('T') ? `${s}Z` : `${s.replace(' ', 'T')}Z`;
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

export function pickLatestSyncAt(...values) {
  let latest = null;
  let latestTs = -Infinity;
  for (const v of values) {
    const d = parseSyncDate(v);
    if (!d) continue;
    const t = d.getTime();
    if (t > latestTs) {
      latestTs = t;
      latest = v;
    }
  }
  return latest;
}

function yearInMadrid(date) {
  return new Intl.DateTimeFormat('es-ES', {
    timeZone: 'Europe/Madrid',
    year: 'numeric'
  }).format(date);
}

/**
 * Formatea un timestamp de sync para la UI (zona Europe/Madrid).
 * compact: omite el año si coincide con el año actual.
 */
export function formatSyncAt(raw, { compact = false } = {}) {
  const d = parseSyncDate(raw);
  if (!d) return raw ? String(raw) : '';
  const opts = {
    timeZone: 'Europe/Madrid',
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  };
  if (!compact || yearInMadrid(d) !== yearInMadrid(new Date())) {
    opts.year = 'numeric';
  }
  return d.toLocaleString('es-ES', opts);
}

/**
 * Fecha civil (YYYY-MM-DD) en Europe/Madrid.
 */
export function hoyMadrid(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid' }).format(date);
}

/**
 * Convierte un valor a YYYY-MM-DD en Europe/Madrid.
 * Fechas civiles puras (YYYY-MM-DD, p. ej. Oura) se dejan tal cual.
 */
export function fechaMadridDe(value) {
  if (value == null || value === '') return '';
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  if (/^\d+$/.test(raw)) {
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return '';
    const ms = n < 1e12 ? n * 1000 : n;
    return hoyMadrid(new Date(ms));
  }
  const d = parseSyncDate(raw);
  if (d) return hoyMadrid(d);
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
  return '';
}

export function esHoyMadrid(value) {
  const fecha = fechaMadridDe(value);
  return Boolean(fecha && fecha === hoyMadrid());
}

/**
 * Fecha y hora de una medición FitDays.
 * Acepta ISO, datetime UTC o unix (segundos o milisegundos).
 */
export function formatMedicionAt(value, { compact = false } = {}) {
  if (value == null || value === '') return '';
  const raw = String(value).trim();
  if (/^\d+$/.test(raw)) {
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return '';
    const ms = n < 1e12 ? n * 1000 : n;
    return formatSyncAt(new Date(ms).toISOString(), { compact });
  }
  return formatSyncAt(value, { compact });
}
